import React from 'react';

class HubspotForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            attempts: 0
        };
        this.createForm = this.createForm.bind(this);
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//js.hsforms.net/forms/v2.js';
        script.async = 'true';
        script.defer = 'true';
        document.getElementsByTagName('head')[0].appendChild(script);

        const component = this;
        setTimeout(function () {
            component.createForm();
        }, 300);
    }

    createForm() {
        const component = this;
        if (!window.hbspt) {
            const attempts = this.state.attempts;
            if (attempts >= 20) {
                return;
            }
            component.setState({
                attempts: attempts + 1
            });
            setTimeout(function () {
                component.createForm();
            }, 100);
            return;
        }
        window.hbspt.forms.create({
            region: 'na1',
            portalId: this.props.portalId,
            formId: this.props.formId,
            target: `#hbspt-${this.props.formId}`,
            onFormSubmitted: function($form, data) {
                if (component.props.callback) {
                    component.props.callback();
                }
            }
        });
    }

    render() {
        return (
            <div className="hbspt-form" id={`hbspt-${this.props.formId}`}>{this.props.children}</div>
        );
    }
}

export default HubspotForm;